import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Modal, Spin } from 'antd';
import useExpiresTimer from '../../hooks/useExpiresTimer';
import { submitAssessment } from '../../store/actions/ProjectActions';
import { useTranslation } from 'react-i18next';

const ExpiresTimer = ({ expiresAt, assessmentId }) => {
  const dispatch = useDispatch();
  const { assessment, error } = useSelector(state => state.project);
  const { t } = useTranslation('project_container');
  const remaining = useExpiresTimer(expiresAt);
  const history = useHistory();
  const location = useLocation();
  const expiredAssessmentsRef = useRef(new Set());
  const [isExpiring, setIsExpiring] = useState(false);

  useEffect(() => {
    // Only check expiration if remaining has been calculated (not null)
    if (
      remaining !== null &&
      remaining <= 0 &&
      expiresAt &&
      !expiredAssessmentsRef.current.has(assessmentId)
    ) {
      expiredAssessmentsRef.current.add(assessmentId);

      // Call submitAssessment to update assessment status to 'submitted'
      if (assessmentId && assessment?.status === 'in_progress' && !error) {
        setIsExpiring(true);
        // Note: Redux thunks don't return promises, so we can't use .finally()
        // The modal will be closed when component re-renders after state update
        setTimeout(() => setIsExpiring(false), 5000); // Fallback timeout
        dispatch(submitAssessment(assessmentId));
      }
    }
  }, [remaining, history, location, expiresAt, assessmentId, dispatch, error, assessment?.status]);

  if (!expiresAt || remaining === null) {
    return <span style={{ color: 'white', fontSize: '36px' }}>00:00:00</span>;
  }

  const hours = Math.floor(remaining / (1000 * 60 * 60));
  const minutes = Math.floor((remaining % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((remaining % (1000 * 60)) / 1000);

  const format = num => (num < 10 ? `0${num}` : num);

  const displayTime = `${format(hours)}:${format(minutes)}:${format(seconds)}`;

  return (
    <>
      <span style={{ color: 'white', fontSize: '36px' }}>{displayTime}</span>

      <Modal
        open={isExpiring}
        footer={null}
        closable={false}
        centered
        width={500}
        bodyStyle={{
          textAlign: 'center',
          padding: '40px',
          background: '#001e3c',
          borderRadius: '8px',
        }}
      >
        <Spin
          size="large"
          style={{ color: '#1890ff' }}
        />
        <div style={{ marginTop: '24px', color: '#fff', fontSize: '20px', fontWeight: '500' }}>
          Time has expired, auto submitting...
        </div>
        <div style={{ marginTop: '12px', color: '#ccc', fontSize: '16px' }}>
          {t('auto_submitting_message')}
        </div>
      </Modal>
    </>
  );
};

export default ExpiresTimer;
